import React, { Component } from 'react';

import { addCircleOutline as add } from 'ionicons/icons';
import {
  withIonLifeCycle,
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonButton,
  IonIcon,
  IonList,
  IonItem,
  IonLabel,
  IonBadge,
  IonChip,
  IonRefresher,
  IonRefresherContent,
  IonSpinner,
} from '@ionic/react';

import PrescriptionRequestService from '../../services/prescriptionRequest';

const STATUS_COLORS = {
  pending: 'warning',
  in_elaboration: 'primary',
  confirmed: 'success',
  delivered: 'tertiary',
  cancelled: 'danger',
};

class PrescriptionRequestsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      requests: [],
      loading: true,
      filterStatus: null,
    };
  }

  async componentDidMount() {
    await this.loadRequests();
  }

  async ionViewWillEnter() {
    await this.loadRequests();
  }

  async loadRequests() {
    this.setState({ loading: true });
    try {
      const filters = {};
      if (this.state.filterStatus) {
        filters.status = this.state.filterStatus;
      }

      const {
        data: { data },
      } = await PrescriptionRequestService.getAll(filters);

      this.setState({ requests: data || [] });
    } catch (error) {
      console.error(error);
    } finally {
      this.setState({ loading: false });
    }
  }

  async handleRefresh(event) {
    await this.loadRequests();
    event.detail.complete();
  }

  setFilter(status) {
    this.setState({ filterStatus: status }, () => this.loadRequests());
  }

  formatDate(dateStr) {
    if (!dateStr) return '';
    const d = new Date(dateStr);

    return d.toLocaleDateString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }

  render() {
    const { requests, loading, filterStatus } = this.state;

    return (
      <>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonBackButton defaultHref="/app/home" />
            </IonButtons>

            <IonTitle>Ricette Inviate</IonTitle>

            <IonButtons slot="end">
              <IonButton onClick={() => this.props.history.push('/app/prescription-request')}>
                <IonIcon icon={add} />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>

        <IonContent>
          <IonRefresher slot="fixed" onIonRefresh={(e) => this.handleRefresh(e)}>
            <IonRefresherContent />
          </IonRefresher>

          <div className="ion-padding" style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            <IonChip color={!filterStatus ? 'primary' : 'medium'} onClick={() => this.setFilter(null)}>
              Tutte
            </IonChip>

            <IonChip
              color={filterStatus === 'pending' ? 'warning' : 'medium'}
              onClick={() => this.setFilter('pending')}
            >
              In attesa
            </IonChip>

            <IonChip
              color={filterStatus === 'in_elaboration' ? 'primary' : 'medium'}
              onClick={() => this.setFilter('in_elaboration')}
            >
              In elaborazione
            </IonChip>

            <IonChip
              color={filterStatus === 'confirmed' ? 'success' : 'medium'}
              onClick={() => this.setFilter('confirmed')}
            >
              Confermate
            </IonChip>

            <IonChip
              color={filterStatus === 'delivered' ? 'tertiary' : 'medium'}
              onClick={() => this.setFilter('delivered')}
            >
              Consegnate
            </IonChip>

            <IonChip
              color={filterStatus === 'cancelled' ? 'danger' : 'medium'}
              onClick={() => this.setFilter('cancelled')}
            >
              Annullate
            </IonChip>
          </div>

          {loading ? (
            <div className="ion-padding ion-text-center">
              <IonSpinner />
            </div>
          ) : requests.length === 0 ? (
            <div className="ion-padding ion-text-center">
              <p>Nessuna ricetta inviata</p>
              <IonButton onClick={() => this.props.history.push('/app/prescription-request')}>
                <IonIcon icon={add} slot="start" /> Invia una ricetta
              </IonButton>
            </div>
          ) : (
            <IonList>
              {requests.map((req) => (
                <IonItem
                  key={req.id}
                  detail
                  onClick={() => this.props.history.push(`/app/prescription-request/${req.id}`)}
                >
                  <IonLabel>
                    <h2>{req.type_label || req.type}</h2>
                    <p>{req.codice_fiscale}</p>
                    <p className="ion-text-wrap">{this.formatDate(req.created_at)}</p>
                    {req.pharmacy_updated_at && (
                      <p className="ion-text-wrap">Aggiornato: {this.formatDate(req.pharmacy_updated_at)}</p>
                    )}
                  </IonLabel>

                  <IonBadge color={STATUS_COLORS[req.status] || 'medium'} slot="end">
                    {req.status_label || req.status}
                  </IonBadge>
                </IonItem>
              ))}
            </IonList>
          )}
        </IonContent>
      </>
    );
  }
}

export default withIonLifeCycle(PrescriptionRequestsList);
